import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage';
import antidrugactivity1 from "../../../assets/CampuLifeImages/antidrugactivity1.jpg"
import antidrugactivity2 from "../../../assets/CampuLifeImages/antidrugactivity2.jpg"
import antidrugactivity3 from "../../../assets/CampuLifeImages/antidrugactivity3.jpg"
import antidrugactivity4 from "../../../assets/CampuLifeImages/antidrugactivity4.jpg"
import antidrugbanner from "../../../assets/CampuLifeImages/antidrugbanner.jpg"


const AntiDrug = () => {
 
  const womenCellContent = {
    name: "antidrug",
    viewmore: true,
    viewless: true,
    contentImg: antidrugbanner,
    para: "The Anti-Drug Cell aims to cultivate a drug-free campus by spreading awareness among students about the harmful effects of substance abuse. It works to empower students to make informed and healthy choices while resisting peer pressure. Through awareness lectures, public rallies, competitions, poster exhibitions, organizing campaigns, workshops, and seminars, the cell fosters an environment of education and prevention. Additionally, the Anti-Drug Cell monitors and identifies any instances of substance misuse on campus and provides timely assistance and guidance to those in need.  ",
    paranext: "By collaborating with health organizations, law enforcement, and the local community, the cell actively contributes to reducing the availability  and use of illegal substances. The overarching goal is to ensure a safe, supportive, and healthy educational space where students can thrive.",
    hover: true,
    title: "Anti Drug Awareness Committee Activities",
    pagename: "Anti Drug Awareness",
     handbook1:"Drug Prevention And Treatment Handbook.pdf",
    fourhover: true
  }


  const hoverContent = [
    { img: antidrugactivity1, para1: "Anti-Drug Awareness Programme in NICAS", para2: "October 24, 2024" },
    { img: antidrugactivity2, para1: "Anti-Drug Awareness Campaign to raise awareness about the dangers of drug use among the public", para2: "" },
    { img: antidrugactivity3, para1: "Students showcased their registration against drug using smart phones.It was conducted to raise awareness among youth using smart phones", para2: "" },
    { img: antidrugactivity4, para1: "Anti-Drug Awareness Pledge Ceremony", para2: "February 21, 2025" }
  ]

  const tableData = [
    { title: "Anti Drug Awareness Members" },
    { headings: [{ heading1: "S.No.", heading2: "Name", heading3: "Designation & Department", heading4: "Position" }] },
    {
      data: [{ id: 1, name: 'Dr. R. Marimuthu', designDept: "Principal", pos: "President" },
      { id: 2, name: 'Dr. N. Siva Kumar', designDept: "Asst. Prof., Department of Tamil", pos: "Co-ordinator" },
      { id: 3, name: 'Mr. V. S. Krishna Prasad', designDept: "Asst. Prof., Department of Computer Science", pos: "Member" },
      { id: 4, name: 'Dr. V. S. Sangeetha', designDept: "Asst. Prof. & Head , Department of Biotechnology (PG)", pos: "Member" },
      { id: 5, name: 'Mr. M. Avudayappa pillai', designDept: "Asst. Prof., Bachelor of Computer Applications (BCA)", pos: "Member" },
      { id: 6, name: 'Mrs. C. Sheeba Christalda', designDept: "Asst. Prof., Bachelor of Business Administaration (BBA)", pos: "Member" }
      ]
    },
    { padding: true }
  ];
  return (
    <>

      <ExtenStudClubGrievPage data={womenCellContent} hoverContent={hoverContent} tableData={tableData} />


    </>
  )
}

export default AntiDrug
